import cx from 'classnames'

import { Divider } from '../../../shared/Divider'
import { useIGAO } from '../../context'
import { withDivider } from '../../utils'

import styles from './item.module.scss'

export function Header ({ item, prevItem }) {
  const { filters } = useIGAO()
  const isHeader = item.type === 'header'
  return (
    <>
      {withDivider(prevItem, filters)}
      <div className={styles.item}>
        <div className={styles.innerBody}>
          <div className={cx(styles.itemLabel, styles[item.type])}>
            {item?.label}
          </div>
        </div>
      </div>
      {isHeader && <Divider />}
    </>
  )
}
